(() => {
  if (window.__TRU_COLLECTION_V2_AJAX_V5__) return;
  window.__TRU_COLLECTION_V2_AJAX_V5__ = true;

  const SECTION_SELECTOR = '.tru-collection-v2';
  const FORM_SELECTOR = '#CollectionFiltersForm';
  const PRODUCT_AREA_SELECTOR = '.tru-collection-v2__products';
  const SUMMARY_SELECTOR = '.tru-filter-mobile-summary';
  const PRODUCT_CONTAINER_SELECTOR = '[data-product-container]';
  const PAGINATION_SELECTOR = '[data-tru-pagination]';
  const LOAD_MORE_SELECTOR = '[data-tru-load-more]';
  const SORT_SELECTOR = '[data-tru-sort]';

  const stateMap = new WeakMap();
  let requestSequence = 0;

  const getSection = (target) =>
    target && target.closest ? target.closest(SECTION_SELECTOR) : null;

  const getForm = (section) =>
    section ? section.querySelector(FORM_SELECTOR) : null;

  const getState = (section) => {
    if (!stateMap.has(section)) {
      stateMap.set(section, {
        activeUrl: new URL(window.location.href),
        timer: null,
        controller: null,
        pendingPromise: null,
        requestId: 0,
      });
    }
    return stateMap.get(section);
  };

  const getFilterBaseUrl = (section) => {
    const raw = section?.dataset?.filterBaseUrl;
    return new URL(raw || window.location.pathname, window.location.origin);
  };

  const makeRequestUrl = (section, publicUrl) => {
    const requestUrl = new URL(publicUrl.toString());
    requestUrl.searchParams.set('section_id', section.dataset.sectionId);
    return requestUrl;
  };

  const parseIncomingSection = (html, sectionId) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.getElementById(sectionId) || doc.querySelector(SECTION_SELECTOR);
  };

  const refreshThemeProductFeatures = () => {
    if (window.MinimogEvents && typeof window.MinimogEvents.emit === 'function') {
      window.MinimogEvents.emit('ON_PRODUCT_LIST_UPDATED');
    }

    if (typeof window.refreshProductReview === 'function') {
      window.refreshProductReview();
    }

    if (window.MinimogTheme) {
      if (
        window.MinimogTheme.CompareProduct &&
        typeof window.MinimogTheme.CompareProduct.setCompareButtonsState === 'function'
      ) {
        window.MinimogTheme.CompareProduct.setCompareButtonsState();
      }

      if (
        window.MinimogTheme.Wishlist &&
        typeof window.MinimogTheme.Wishlist.setWishlistButtonsState === 'function'
      ) {
        window.MinimogTheme.Wishlist.setWishlistButtonsState();
      }

      if (typeof window.MinimogTheme.initProductCard === 'function') {
        window.MinimogTheme.initProductCard();
      }
    }
  };

  const setLiveLoading = (section, loading) => {
    if (!section) return;

    section.classList.toggle('is-live-filtering', loading);

    const panel = section.querySelector('.tru-filter-panel');
    if (panel) {
      panel.classList.toggle('is-preview-loading', loading);
    }
  };

  const openFilters = (section) => {
    if (!section) return;

    section.classList.add('is-filter-open');
    document.documentElement.classList.add('tru-filter-lock');

    const stickyBar = section.querySelector('[data-tru-sticky-filter]');
    if (stickyBar) {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }

    const header = document.querySelector('.m-header');
    if (header) {
      header.classList.remove('tru-filter-bar-visible');
    }

    section
      .querySelectorAll('[data-tru-filter-open]')
      .forEach((el) => el.setAttribute('aria-expanded', 'true'));
  };

  const closeFiltersUI = (section) => {
    if (!section) return;

    section.classList.remove('is-filter-open');
    document.documentElement.classList.remove('tru-filter-lock');

    requestStickyFilterSync();

    section
      .querySelectorAll('[data-tru-filter-open]')
      .forEach((el) => el.setAttribute('aria-expanded', 'false'));
  };


  let stickyFilterTicking = false;

  const syncStickyFilter = () => {
    let anyStickyVisible = false;

    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      const stickyBar = section.querySelector('[data-tru-sticky-filter]');
      const toolbar = section.querySelector('.tru-collection-v2__toolbar');

      if (!stickyBar || !toolbar) return;

      if (section.classList.contains('is-filter-open')) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
        return;
      }

      /*
       * Match the real header heights used by the site:
       * desktop > 1024px = 84px
       * tablet/mobile <= 1024px = 56px
       *
       * Important: the sticky filter does NOT appear just because the
       * original filter card has scrolled away. It waits until the
       * products toolbar (Showing X of Y / Sort by) has also passed
       * behind the header PLUS a small reveal buffer. That prevents the
       * sticky bar from dropping immediately after View Products scrolls
       * the shopper to the grid and gives the toolbar a moment to breathe.
       */
      const headerOffset = window.innerWidth > 1024 ? 84 : 56;

      /*
       * Give the products toolbar some breathing room before the sticky
       * filter arrives. On desktop this deliberately waits an extra 72px
       * after the toolbar has passed the header, so the shopper can still
       * see the Showing / Sort By row before the filter bar replaces that
       * visual space. Smaller screens use a lighter 36px buffer.
       */
      const revealBuffer = window.innerWidth > 1024 ? 72 : 36;
      const toolbarRect = toolbar.getBoundingClientRect();
      const shouldShow = toolbarRect.bottom <= (headerOffset - revealBuffer);

      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');

      if (shouldShow) {
        anyStickyVisible = true;
      }
    });

    const header = document.querySelector('.m-header');

    if (header) {
      header.classList.toggle('tru-filter-bar-visible', anyStickyVisible);
    }
  };

  const requestStickyFilterSync = () => {
    if (stickyFilterTicking) return;

    stickyFilterTicking = true;

    window.requestAnimationFrame(() => {
      syncStickyFilter();
      stickyFilterTicking = false;
    });
  };

  const scrollToProducts = (section) => {
    if (!section) return;

    const products = section.querySelector(PRODUCT_AREA_SELECTOR);
    if (!products) return;

    /*
     * CSS controls the offset with scroll-margin-top:
     *   desktop > 1024px = 110px
     *   tablet/mobile <= 1024px = 70px
     *
     * Using the browser's native element scrolling keeps the entire
     * movement smooth in either direction with no post-scroll correction.
     */
    products.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const buildFilterUrlFromForm = (section, form) => {
    /*
     * Important:
     * We intentionally use /collections/all as the request base.
     * This keeps Category behaving as a true metafield filter even if the
     * shopper originally landed on /collections/cleanse, /color, /style,
     * or /treat.
     *
     * This URL is used ONLY for background Shopify section requests.
     * It is never pushed into the browser address bar.
     */
    const publicUrl = getFilterBaseUrl(section);
    const formData = new FormData(form);

    for (const [key, value] of formData.entries()) {
      if (value === '' || value == null) continue;

      if (key.startsWith('filter.')) {
        publicUrl.searchParams.append(key, value);
      } else if (key === 'sort_by' || key === 'q' || key === 'options[prefix]') {
        publicUrl.searchParams.set(key, value);
      }
    }

    publicUrl.searchParams.delete('page');
    return publicUrl;
  };

  const getIncomingTotal = (incomingSection) => {
    const countNode = incomingSection?.querySelector('[data-tru-product-count]');
    return countNode
      ? Number(countNode.dataset.totalResults || 0)
      : 0;
  };

  const updateApplyButtonCount = (section, total) => {
    if (!section) return;

    const label = `View ${total} ${total === 1 ? 'Product' : 'Products'}`;

    section
      .querySelectorAll('[data-tru-apply-label]')
      .forEach((node) => {
        node.textContent = label;
      });
  };

  const syncDrawerSelections = (section, incomingSection) => {
    const currentForm = getForm(section);
    const incomingForm = getForm(incomingSection);
    if (!currentForm || !incomingForm) return;

    const incomingMap = new Map();

    incomingForm
      .querySelectorAll('input[type="checkbox"]')
      .forEach((input) => {
        incomingMap.set(`${input.name}\u0000${input.value}`, input);
      });

    currentForm
      .querySelectorAll('input[type="checkbox"]')
      .forEach((input) => {
        const incoming = incomingMap.get(`${input.name}\u0000${input.value}`);

        if (incoming) {
          input.checked = incoming.checked;
        } else if (!input.closest('.tru-filter-group--category')) {
          input.checked = false;
        }
      });
  };

  const updateDrawerAvailability = (section, incomingSection) => {
    const currentForm = getForm(section);
    const incomingForm = getForm(incomingSection);
    if (!currentForm || !incomingForm) return;

    const incomingMap = new Map();

    incomingForm
      .querySelectorAll('input[type="checkbox"]')
      .forEach((input) => {
        incomingMap.set(`${input.name}\u0000${input.value}`, input);
      });

    currentForm
      .querySelectorAll('input[type="checkbox"]')
      .forEach((input) => {
        const option = input.closest('.tru-filter-option');
        if (!option) return;

        // Category choices always remain visible and selectable.
        if (option.classList.contains('tru-category-filter-option')) {
          input.disabled = false;
          option.classList.remove('is-disabled');
          return;
        }

        // A selected option must stay available so the shopper can uncheck it.
        if (input.checked) {
          input.disabled = false;
          option.classList.remove('is-disabled');
          return;
        }

        const incomingInput = incomingMap.get(`${input.name}\u0000${input.value}`);
        const available = Boolean(incomingInput && !incomingInput.disabled);

        input.disabled = !available;
        option.classList.toggle('is-disabled', !available);

        const currentCount = option.querySelector('.tru-filter-option__count');

        if (currentCount && incomingInput) {
          const incomingOption = incomingInput.closest('.tru-filter-option');
          const incomingCount = incomingOption
            ? incomingOption.querySelector('.tru-filter-option__count')
            : null;

          if (incomingCount) {
            currentCount.textContent = incomingCount.textContent;
          }
        }
      });
  };

  const replaceSummary = (section, incomingSection) => {
    const currentSummary = section.querySelector(SUMMARY_SELECTOR);
    const incomingSummary = incomingSection.querySelector(SUMMARY_SELECTOR);

    if (!currentSummary || !incomingSummary) return;

    currentSummary.replaceWith(document.importNode(incomingSummary, true));
  };

  const replaceProductArea = (section, incomingSection) => {
    const currentProducts = section.querySelector(PRODUCT_AREA_SELECTOR);
    const incomingProducts = incomingSection.querySelector(PRODUCT_AREA_SELECTOR);

    if (!currentProducts || !incomingProducts) return;

    currentProducts.replaceWith(document.importNode(incomingProducts, true));
  };

  const fetchLiveSection = async (
    section,
    publicUrl,
    {
      syncForm = false,
      updateProducts = true,
      updateSummary = true,
    } = {}
  ) => {
    if (!section) return null;

    const state = getState(section);

    if (state.controller) {
      state.controller.abort();
    }

    const controller = new AbortController();
    state.controller = controller;

    const requestId = ++requestSequence;
    state.requestId = requestId;

    setLiveLoading(section, true);

    try {
      const requestUrl = makeRequestUrl(section, publicUrl);

      const response = await fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal,
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const incomingSection = parseIncomingSection(html, section.id);

      if (!incomingSection) {
        throw new Error('Could not find the updated TRU collection section.');
      }

      // Ignore a stale response that finished after a newer request.
      if (state.requestId !== requestId) return null;

      const total = getIncomingTotal(incomingSection);

      if (syncForm) {
        syncDrawerSelections(section, incomingSection);
      }

      updateDrawerAvailability(section, incomingSection);
      updateApplyButtonCount(section, total);

      if (updateSummary) {
        replaceSummary(section, incomingSection);
      }

      if (updateProducts) {
        replaceProductArea(section, incomingSection);
        refreshThemeProductFeatures();
      }

      state.activeUrl = new URL(publicUrl.toString());

      document.dispatchEvent(
        new CustomEvent('tru:collection:live-updated', {
          detail: {
            sectionId: section.id,
            total,
          },
        })
      );

      requestStickyFilterSync();

      return incomingSection;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('[TRU Product Listing] Live filter update failed:', error);
      }
      return null;
    } finally {
      if (state.requestId === requestId) {
        setLiveLoading(section, false);
        state.controller = null;
      }
    }
  };

  const runLiveFilterUpdate = (section) => {
    if (!section) return Promise.resolve(null);

    const state = getState(section);
    const form = getForm(section);

    if (!form) return Promise.resolve(null);

    if (state.timer) {
      window.clearTimeout(state.timer);
      state.timer = null;
    }

    const publicUrl = buildFilterUrlFromForm(section, form);

    const promise = fetchLiveSection(section, publicUrl, {
      syncForm: false,
      updateProducts: true,
      updateSummary: true,
    });

    state.pendingPromise = promise;

    promise.finally(() => {
      if (state.pendingPromise === promise) {
        state.pendingPromise = null;
      }
    });

    return promise;
  };

  const scheduleLiveFilterUpdate = (section) => {
    if (!section) return;

    const state = getState(section);

    if (state.timer) {
      window.clearTimeout(state.timer);
    }

    state.timer = window.setTimeout(() => {
      state.timer = null;
      runLiveFilterUpdate(section);
    }, 140);
  };

  const flushLiveFilterUpdate = async (section) => {
    if (!section) return null;

    const state = getState(section);

    if (state.timer) {
      window.clearTimeout(state.timer);
      state.timer = null;
      return runLiveFilterUpdate(section);
    }

    if (state.pendingPromise) {
      return state.pendingPromise;
    }

    return null;
  };

  const finishFilterSession = async (section) => {
    if (!section) return;

    await flushLiveFilterUpdate(section);
    closeFiltersUI(section);
    scrollToProducts(section);
  };


  const closeFilterSession = async (section) => {
    if (!section) return;

    await flushLiveFilterUpdate(section);
    closeFiltersUI(section);
  };


  const handleExternalFilterUrl = async (section, href) => {
    if (!section || !href) return;

    const publicUrl = new URL(href, window.location.origin);

    await fetchLiveSection(section, publicUrl, {
      syncForm: true,
      updateProducts: true,
      updateSummary: true,
    });
  };

  const handleClearAll = async (section) => {
    if (!section) return;

    const publicUrl = getFilterBaseUrl(section);

    const sortSelect = section.querySelector(SORT_SELECTOR);
    if (sortSelect?.value) {
      publicUrl.searchParams.set('sort_by', sortSelect.value);
    }

    await fetchLiveSection(section, publicUrl, {
      syncForm: true,
      updateProducts: true,
      updateSummary: true,
    });
  };

  const handleSort = (select) => {
    const section = getSection(select);
    if (!section) return;

    const state = getState(section);
    const publicUrl = new URL(state.activeUrl.toString());

    publicUrl.searchParams.set('sort_by', select.value);
    publicUrl.searchParams.delete('page');

    const form = getForm(section);
    const hiddenSort = form?.querySelector('[name="sort_by"]');
    if (hiddenSort) {
      hiddenSort.value = select.value;
    }

    fetchLiveSection(section, publicUrl, {
      syncForm: false,
      updateProducts: true,
      updateSummary: false,
    });
  };

  const handleLoadMore = async (button) => {
    if (button.classList.contains('is-loading')) return;

    const section = getSection(button);
    const pagination = button.closest(PAGINATION_SELECTOR);
    const productContainer = section
      ? section.querySelector(PRODUCT_CONTAINER_SELECTOR)
      : null;

    if (!section || !pagination || !productContainer) return;

    const state = getState(section);
    const currentPage = Number(pagination.dataset.currentPage || 1);
    const totalPages = Number(pagination.dataset.totalPages || 1);
    const nextPage = currentPage + 1;

    if (nextPage > totalPages) {
      pagination.remove();
      return;
    }

    button.classList.add('is-loading', 'm-spinner-loading');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      const publicUrl = new URL(state.activeUrl.toString());
      publicUrl.searchParams.set('page', String(nextPage));

      const requestUrl = makeRequestUrl(section, publicUrl);

      const response = await fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const incomingSection = parseIncomingSection(html, section.id);
      const incomingContainer = incomingSection
        ? incomingSection.querySelector(PRODUCT_CONTAINER_SELECTOR)
        : null;

      if (!incomingContainer) {
        throw new Error('Could not find products on the next page.');
      }

      incomingContainer
        .querySelectorAll('.m-product-item')
        .forEach((product) => {
          productContainer.appendChild(document.importNode(product, true));
        });

      pagination.dataset.currentPage = String(nextPage);

      const countNode = section.querySelector('[data-tru-product-count]');

      if (countNode) {
        const totalResults = Number(countNode.dataset.totalResults || 0);
        const shown = productContainer.querySelectorAll('.m-product-item').length;

        countNode.textContent =
          `Showing ${Math.min(shown, totalResults)} of ${totalResults} products`;
      }

      if (nextPage >= totalPages) {
        pagination.remove();
      } else {
        button.classList.remove('is-loading', 'm-spinner-loading');
        button.removeAttribute('aria-busy');
        button.disabled = false;
      }

      refreshThemeProductFeatures();

      document.dispatchEvent(
        new CustomEvent('tru:collection:products-appended', {
          detail: {
            sectionId: section.id,
            page: nextPage,
          },
        })
      );
    } catch (error) {
      console.error('[TRU Product Listing] Load more failed:', error);

      button.classList.remove('is-loading', 'm-spinner-loading');
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  };

  document.addEventListener('click', (event) => {
    const clearAll =
      event.target.closest &&
      event.target.closest(`${SECTION_SELECTOR} .tru-filter-clear`);

    if (clearAll) {
      event.preventDefault();
      event.stopPropagation();

      const section = getSection(clearAll);
      handleClearAll(section);
      return;
    }

    const removeChip =
      event.target.closest &&
      event.target.closest(`${SECTION_SELECTOR} [data-tru-remove-chip]`);

    if (removeChip) {
      event.preventDefault();
      event.stopPropagation();

      const section = getSection(removeChip);
      const href = removeChip.getAttribute('href');

      handleExternalFilterUrl(section, href);
      return;
    }

    const openTrigger =
      event.target.closest &&
      event.target.closest(
        `${SECTION_SELECTOR} [data-tru-filter-open], ${SECTION_SELECTOR} [data-tru-filter-open-button]`
      );

    if (openTrigger && !event.target.closest('[data-tru-stop-open]')) {
      event.preventDefault();

      const section = getSection(openTrigger);
      openFilters(section);
      return;
    }

    const closeTrigger =
      event.target.closest &&
      event.target.closest(`${SECTION_SELECTOR} [data-tru-filter-close]`);

    if (closeTrigger) {
      event.preventDefault();
      event.stopPropagation();

      closeFilterSession(getSection(closeTrigger));
      return;
    }

    const viewMore =
      event.target.closest &&
      event.target.closest(`${SECTION_SELECTOR} [data-tru-view-more]`);

    if (viewMore) {
      event.preventDefault();

      const group = viewMore.closest('[data-tru-filter-group]');
      const extras = group
        ? group.querySelectorAll('.tru-filter-option-extra')
        : [];

      const expanded = viewMore.classList.toggle('is-expanded');

      extras.forEach((item) => {
        item.hidden = !expanded;
      });

      const moreLabel = viewMore.querySelector('[data-more-label]');
      const lessLabel = viewMore.querySelector('[data-less-label]');

      if (moreLabel) moreLabel.hidden = expanded;
      if (lessLabel) lessLabel.hidden = !expanded;
      return;
    }

    const loadMoreButton =
      event.target.closest &&
      event.target.closest(`${SECTION_SELECTOR} ${LOAD_MORE_SELECTOR}`);

    if (loadMoreButton) {
      event.preventDefault();
      event.stopImmediatePropagation();

      handleLoadMore(loadMoreButton);
      return;
    }

    const applyButton =
      event.target.closest &&
      event.target.closest(`${SECTION_SELECTOR} [data-tru-apply-filters]`);

    if (applyButton) {
      event.preventDefault();
      event.stopImmediatePropagation();

      finishFilterSession(getSection(applyButton));
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form =
        event.target.closest &&
        event.target.closest(`${SECTION_SELECTOR} ${FORM_SELECTOR}`);

      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document
        .querySelectorAll(`${SECTION_SELECTOR}.is-filter-open`)
        .forEach((section) => {
          closeFilterSession(section);
        });
    }

    const openTrigger =
      event.target.closest &&
      event.target.closest(`${SECTION_SELECTOR} [data-tru-filter-open]`);

    if (
      openTrigger &&
      (event.key === 'Enter' || event.key === ' ')
    ) {
      event.preventDefault();
      openTrigger.click();
    }
  });

  document.addEventListener(
    'change',
    (event) => {
      const sort =
        event.target.closest &&
        event.target.closest(`${SECTION_SELECTOR} ${SORT_SELECTOR}`);

      if (sort) {
        event.preventDefault();
        event.stopImmediatePropagation();

        handleSort(sort);
        return;
      }

      const checkbox =
        event.target.closest &&
        event.target.closest(
          `${SECTION_SELECTOR} ${FORM_SELECTOR} input[type="checkbox"]`
        );

      if (!checkbox) return;

      /*
       * Stop any theme/global storefront-filter handlers.
       * The checkbox changes visually immediately, while the filtered Shopify
       * section is fetched silently in the background.
       */
      event.stopImmediatePropagation();

      scheduleLiveFilterUpdate(getSection(checkbox));
    },
    true
  );

  document.addEventListener(
    'input',
    (event) => {
      const checkbox =
        event.target.closest &&
        event.target.closest(
          `${SECTION_SELECTOR} ${FORM_SELECTOR} input[type="checkbox"]`
        );

      if (!checkbox) return;

      event.stopImmediatePropagation();
    },
    true
  );

  window.addEventListener('scroll', requestStickyFilterSync, { passive: true });
  window.addEventListener('resize', requestStickyFilterSync);
  document.addEventListener('DOMContentLoaded', requestStickyFilterSync);
  requestStickyFilterSync();

})();
